import {
  CHAT_HISTORY_QUERY_KEY,
  CHAT_LIST_QUERY_KEY,
} from "@frontend-shared/constants";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import { chatApi } from "@/api/services";

export const useDeleteChat = (
  onSuccess?: (uuid: string) => void,
  onError?: () => void,
): ReturnType<typeof useMutation<void, Error, string>> => {
  const { t } = useTranslation("sidebar");
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (uuid: string) => chatApi.deleteChat(uuid),
    onSuccess: (_data, uuid) => {
      onSuccess?.(uuid);
      queryClient.removeQueries({ queryKey: [CHAT_HISTORY_QUERY_KEY, uuid] });
      queryClient.invalidateQueries({ queryKey: [CHAT_LIST_QUERY_KEY] });
      queryClient.invalidateQueries({ queryKey: [CHAT_HISTORY_QUERY_KEY] });
    },
    onError: () => {
      onError?.();
    },
    meta: {
      fallbackMessage: t("chat_list.delete_chat.error"),
    },
  });
};
